
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14 2.8c6.187 0 11.2 5.014 11.2 11.2 0 6.186-5.013 11.2-11.2 11.2-6.185 0-11.2-5.014-11.2-11.2C2.8 7.814 7.816 2.8 14 2.8z","fill":"url(#paint0_linear_1247_26506)"}}),_c('path',{attrs:{"d":"M7.94 11.042v4.44a1.817 1.817 0 001.823 1.807h6.472a.33.33 0 00.332-.328v-4.44a1.817 1.817 0 00-1.824-1.808H8.272a.33.33 0 00-.333.329zm9.04 1.731l2.671-1.951c.232-.192.413-.144.413.204v5.951c0 .396-.22.349-.413.204l-2.671-1.948v-2.46z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_1247_26506","x1":"5.768","y1":"6.406","x2":"23.547","y2":"19.861","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#4A8CFF"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#23B7EC"}})])])])
          )
        }
      }
    